<template>
  <div class="login-container">
    <div class="login-logo">
      <img src="@/assets/logo_color.png" alt="" />
    </div>
    <div class="title-container">
      <div class="title">
        <div>SenseTime</div>
        <div>加练管理平台</div>
      </div>
    </div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
      label-position="left">
      <el-form-item prop="username">
        <span class="svg-container">
          <!-- <svg-icon icon-class="user" /> -->
          {{ $t('login.usernameLabel') }}:
        </span>
        <el-input v-model="loginForm.userName" :placeholder="$t('login.username')" name="username" type="text"
          auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <!-- <svg-icon icon-class="password" /> -->
          {{ $t('login.passwordLabel') }}:
        </span>
        <el-input v-model="loginForm.password" :type="passwordType" :placeholder="$t('login.password')" name="password"
          auto-complete="on" @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>
      <el-button :loading="loading" type="primary" class="login-button" round @click.native.prevent="handleLogin">
        {{ $t("login.logIn") }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { loginByUsername, getUserInfo } from "@/api/login";
import { validUsername } from "@/utils/validate";
import { setToken } from "@/utils/auth";

export default {
  name: "Login",
  components: {},
  data () {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("Please enter the correct user name"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("The password can not be less than 6 digits"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        userName: "",
        password: "",
        vaverify: ""
      },
      loginRules: {
        userName: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      passwordType: "password",
      loading: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created () { },
  mounted () { },
  destroyed () { },
  methods: {
    showPwd () {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    handleLogin () {
      let type = 1;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.userName === 'admin') {
            type = 2
          }
          loginByUsername({ ...this.loginForm, type })
            .then((res) => {
              const { code, data } = res;
              if (code === "0") {
                this.$store.commit("SET_TOKEN", data.accessToken);
                setToken(data.accessToken);
                this.getUserInfoFun()
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 获取用户信息
    getUserInfoFun () {
      getUserInfo().then(res => {
        const user = JSON.stringify(res.data)
        window.localStorage.setItem('userInfo', user);
        JSON.stringify(window.localStorage.setItem('isLogin', 1));

        if (window.localStorage.getItem('userInfo')) {
          const path = JSON.parse(window.localStorage.getItem('userInfo')).menus[0];
  
          if (path.childMenu.length > 0) {
            this.$router.push({
              path: `${path.path}/${path.childMenu[0].path}`
            })
          } else {
            this.$router.push({
              path: `${path.path}`
            })
          }
        }
      })
    },
  },
  // beforeRouteLeave (to, from, next) {
  //   next()
  // }
};
</script>

<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #86909c;
$cursor: #86909c;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;

    &::first-line {
      color: $light_gray;
    }
  }
}


/* reset element-ui css */
.login-container {
  background: url("~@/assets/login_bg.png") no-repeat;

  .el-input {
    display: inline-block;
    height: 40px;
    width: 80%;

    input {
      height: 100%;
      margin-left: 16px;
      //   background: transparent;
      //   border: 0px;
      //   -webkit-appearance: none;
      //   border-radius: 0px;
      //   padding: 12px 5px 12px 15px;
      //   color: $light_gray;
      //   height: 47px;
      //   caret-color: $cursor;
      //   &:-webkit-autofill {
      //     // -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
      //     // -webkit-text-fill-color: $cursor !important;
      //   }
    }
  }

  .el-form-item {
    // border-bottom: 1px solid rgba(134, 144, 156, 0.25);
    margin-bottom: 40px;
    background: transparent;
    color: #000;

    &__error {
      left: 75px;
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@mixin font-box($fs, $fw, $fc) {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: $fw;
  font-size: $fs;
  color: $fc;
}

// $bg:#2d3a4b;
@mixin position-fun($p, $t, $r, $b, $l) {
  position: $p;
  top: $t;
  right: $r;
  bottom: $b;
  left: $l;

}

$bg: transparent;
$dark_gray: #4e5969;
$light_gray: #86909c;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: scroll;
  position: relative;
  padding-left: 160px;
  box-sizing: border-box;

  .login-logo {
    position: absolute;
    top: 80px;
    width: 212px;
    height: 60px;
  }

  .login-form {
    position: absolute;
    top: 370px;
    width: 470px;
    // height: 500px;
    max-width: 100%;
    // padding: 160px 35px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px #ccc;
    padding: 50px 30px 20px 20px;
    border-radius: 4px;
    overflow: hidden;
  }

  .login-button {
    background: #3780e8;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    margin-top: 20px;
    margin-bottom: 30px;
    letter-spacing: 10px;
    @include font-box(20px, 400, #fff);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    // padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 60px;
    display: inline-block;
    text-align: right;
    @include font-box(16px, 500, #4e5969)
  }

  .title-container {
    position: relative;
    top: 200px;

    // background: red;
    .title {
      @include font-box(64px, 600, #4e5969);

      & :nth-child(2) {
        font-size: 32px;
      }
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    right: 24px;
    top: 3px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .verify-img {
    // position: absolute;
    // right: 8px;
    // top: 0px;
    @include position-fun(absolute, 0px, 8px, null, null);
    color: $dark_gray;
    cursor: pointer;
    user-select: none;

    img {
      width: 140px;
      height: 40px;
      display: block;
    }
  }
}
</style>
